var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.991 21C7.02161 20.995 2.99669 16.9634 3 11.994C3.00332 7.02461 7.03361 2.99835 12.003 3C16.9724 3.00166 21 7.0306 21 12C20.997 16.9728 16.9638 21.002 11.991 21ZM4.8 12.1548C4.84259 16.1159 8.077 19.2986 12.0383 19.2774C15.9996 19.256 19.1996 16.0387 19.1996 12.0774C19.1996 8.11605 15.9996 4.89879 12.0383 4.87739C8.077 4.85621 4.84259 8.03888 4.8 12V12.1548ZM12.9 16.5H11.1V14.7H12.9V16.5ZM12.9 12.9H11.1V7.5H12.9V12.9Z",
    fill: "#242731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/errorOutline.0abc627d91e6650e06ecaab2270a6059.svg";
export { ForwardRef as ReactComponent };